module.exports = __webpack_public_path__ + "static/img/mica-2.ea3ca80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/mica-2.jpg
// module id = Qfjg
// module chunks = 1